"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pseudoStylingFixForSafari = void 0;
function pseudoStylingFixForSafari() {
  /*
   * Allow pseudo styling to work in mobile safari. For more information about matching desktop behavior in safari mobile, see:
   * https://developer.apple.com/library/archive/documentation/AppleApplications/Reference/SafariWebContent/AdjustingtheTextSize/AdjustingtheTextSize.html#//apple_ref/doc/uid/TP40006510-SW5
   */
  document.addEventListener('touchstart', function () {}, true);
}
exports.pseudoStylingFixForSafari = pseudoStylingFixForSafari;